// extracted by mini-css-extract-plugin
export default {"container":"hvMDKTY3","inner":"j_7jvIQz","menu":"PwyrE3WE","disclaimer":"NNULPoxs","loader":"VFoi45Tn"};